import ApexCharts from 'apexcharts'
const { default: BriteChartApp } = require('./x.app.min');

window.addEventListener('load', (event) => {
    var moment = require('moment');
    var briteChartApp = window.briteChartApp || {};
    !(function (i) {
        "use strict";
        function t() {
            (this.body = i("body")), (this.window = i(window)), (this.menuContainer = i("#leftside-menu-container"));
        }
        (t.prototype._reset = function () {
            this.body.removeAttr("data-leftbar-theme");
        }),
            (t.prototype.activateCondensedSidebar = function () {
                this.body.attr("data-leftbar-compact-mode", "condensed");
            }),
            (t.prototype.deactivateCondensedSidebar = function () {
                this.body.removeAttr("data-leftbar-compact-mode");
            }),
            (t.prototype.activateScrollableSidebar = function () {
                this.body.attr("data-leftbar-compact-mode", "scrollable");
            }),
            (t.prototype.deactivateScrollableSidebar = function () {
                this.body.removeAttr("data-leftbar-compact-mode");
            }),
            (t.prototype.activateDefaultTheme = function () {
                this._reset();
            }),
            (t.prototype.activateLightTheme = function () {
                this._reset(), this.body.attr("data-leftbar-theme", "light");
            }),
            (t.prototype.activateDarkTheme = function () {
                this._reset(), this.body.attr("data-leftbar-theme", "dark");
            }),
            (t.prototype.initMenu = function () {
                var t,
                    e = this;
                this._reset(),
                    i(document).on("click", ".button-menu-mobile", function (t) {
                        t.preventDefault(),
                            e.body.toggleClass("sidebar-enable"),
                            "full" === e.body.attr("data-layout") ? e.body.toggleClass("hide-menu") : "condensed" === e.body.attr("data-leftbar-compact-mode") ? e.deactivateCondensedSidebar() : e.activateCondensedSidebar();
                    }),
                    i(".side-nav").length &&
                        ((t = i(".side-nav li .collapse")),
                        i(".side-nav li [data-bs-toggle='collapse']").on("click", function (t) {
                            return !1;
                        }),
                        t.on({
                            "show.bs.collapse": function (t) {
                                var e = i(t.target).parents(".collapse.show");
                                i(".side-nav .collapse.show").not(t.target).not(e).collapse("hide");
                            },
                        }),
                        i(".side-nav a").each(function () {
                            var t,
                                e,
                                a,
                                o = window.location.href.split(/[?#]/)[0];
                            this.href == o &&
                                (i(this).addClass("active"),
                                i(this).parent().addClass("menuitem-active"),
                                i(this).parent().parent().parent().addClass("show"),
                                i(this).parent().parent().parent().parent().addClass("menuitem-active"),
                                "sidebar-menu" !== (t = i(this).parent().parent().parent().parent().parent().parent()).attr("id") && t.addClass("show"),
                                i(this).parent().parent().parent().parent().parent().parent().parent().addClass("menuitem-active"),
                                "wrapper" !== (e = i(this).parent().parent().parent().parent().parent().parent().parent().parent().parent()).attr("id") && e.addClass("show"),
                                (a = i(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().parent()).is("body") || a.addClass("menuitem-active"));
                        }));
                var a = document.querySelectorAll("ul.navbar-nav .dropdown .dropdown-toggle"),
                    o = !1;
                a.forEach(function (a) {
                    a.addEventListener("click", function (t) {
                        var e;
                        a.parentElement.classList.contains("nav-item") ||
                            ((o = !0),
                            (e = a.parentElement.parentElement.parentElement.querySelector(".nav-link")),
                            bootstrap.Dropdown.getInstance(e).show(),
                            a.ariaExpanded ? bootstrap.Dropdown.getInstance(a).hide() : bootstrap.Dropdown.getInstance(e).show(),
                            (o = !0));
                    }),
                        a.addEventListener("hide.bs.dropdown", function (t) {
                            o && (t.preventDefault(), t.stopPropagation(), (o = !1));
                        }),
                        a.addEventListener("show.bs.dropdown", function (t) {
                            o || a.parentElement.classList.contains("nav-item") || (t.preventDefault(), t.stopPropagation(), (o = !0));
                        });
                });
            }),
            (t.prototype.init = function () {
                this.initMenu();
            }),
            (i.LeftSidebar = new t()),
            (i.LeftSidebar.Constructor = t);
    })(window.jQuery),
    (function (i) {
            "use strict";
            function t() {
                (this.$body = i("body")), (this.$window = i(window));
            }
    
            let start = moment().subtract(0, 'days');
            let end = moment();

            const current_parh = window.location.pathname;

            if (current_parh == '/players/cricket/dashboard') {
                let local_start = localStorage.getItem('batting_dashboard_start_date');
                let local_end = localStorage.getItem('batting_dashboard_end_date');
                if (local_start !== null && local_end !== null){
                    start = moment(local_start, 'YYYY-MM-DD')
                    end = moment(local_end, 'YYYY-MM-DD')
                }
            }

            if (current_parh == '/players/cricket/bowler_dashboard') {
                let local_start = localStorage.getItem('bowling_dashboard_start_date');
                let local_end = localStorage.getItem('bowling_dashboard_end_date');
                if (local_start !== null && local_end !== null){
                    start = moment(local_start, 'YYYY-MM-DD')
                    end = moment(local_end, 'YYYY-MM-DD')
                }
            }

            const getMiddledData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                let url = `/players/cricket/short_type`;
                let payload = {
                    bat_contact: 'Middled',
                    start_date,
                    end_date,
                    compare_with_start,
                    compare_with_end,
                    selected_range_type
                }
                let response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: JSON.stringify(payload)
                });
                if (response.ok) { // if HTTP-status is 200-299
                    // get the response body (the method explained below)
                    let json = await response.json();
                    if (document.querySelector("#total-middled-sum") && document.querySelector("#total-middled-sum").textContent) {
                    document.querySelector("#total-middled-sum").textContent = json['total'];
                    }
                    
                    if (json['status'] == 'UP'){
                    $("#middled-stat").html(`
                        <span class="text-success me-2">
                            <i class="mdi mdi-arrow-up-bold"></i> 
                            ${json['current_percent']}%
                        </span>
                        <span>than ${json['selected_range_type']}</span>
                    `);
                    } else {
                    $("#middled-stat").html(`
                        <span class="text-danger me-2">
                            <i class="mdi mdi-arrow-down-bold"></i>
                            ${json['current_percent']}%
                        </span>
                        <span>than ${json['selected_range_type']}</span>
                    `);
                    }
                    window.totalMiddledTiles.updateSeries(json['data'])
                } else {
                    alert("HTTP-Error: " + response.status);
                }
            }

            const getEdgeData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                    let url = `/players/cricket/short_type`;
                    let payload = {
                        bat_contact: 'edged',
                        start_date,
                        end_date,
                        compare_with_start,
                        compare_with_end,
                        selected_range_type
                    }
                    let response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                            // 'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: JSON.stringify(payload)
                    });
                    if (response.ok) { // if HTTP-status is 200-299
                        // get the response body (the method explained below)
                        let json = await response.json();
                        if (json['status'] == 'UP'){
                        $("#edges-stat").html(`
                            <span class="text-success me-2">
                                <i class="mdi mdi-arrow-up-bold"></i> 
                                ${json['current_percent']}%
                            </span>
                            <span>than ${json['selected_range_type']}</span>
                        `) ;
                        } else {
                        $("#edges-stat").html(`
                            <span class="text-danger me-2">
                                <i class="mdi mdi-arrow-down-bold"></i>
                                ${json['current_percent']}%
                            </span>
                            <span>than ${json['selected_range_type']}</span>
                        `) ;

                        }
                        document.querySelector("#total-edge-sum").textContent = json['total'];
                        window.totalEdgesTiles.updateSeries(json['data'])
                    } else {
                        alert("HTTP-Error: " + response.status);
                    }
            }

            const getBeatenData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                        let url = `/players/cricket/short_type`;
                        let payload = {
                            bat_contact: 'beaten',
                            start_date,
                            end_date,
                            compare_with_start,
                            compare_with_end,
                            selected_range_type
                        }
                        let response = await fetch(url, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                              // 'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: JSON.stringify(payload)
                        });
                        if (response.ok) { // if HTTP-status is 200-299
                          // get the response body (the method explained below)
                          let json = await response.json();

                          if (json['status'] == 'UP'){
                            $("#beaten-stat").html(`
                                <span class="text-success me-2">
                                    <i class="mdi mdi-arrow-up-bold"></i> 
                                    ${json['current_percent']}%
                                </span>
                                <span>than ${json['selected_range_type']}</span>
                            `) ;
                          } else {
                            $("#beaten-stat").html(`
                                <span class="text-danger me-2">
                                    <i class="mdi mdi-arrow-down-bold"></i>
                                    ${json['current_percent']}%
                                </span>
                                <span>than ${json['selected_range_type']}</span>
                            `) ;

                          }

                          if (document.querySelector("#total-beaten-sum") && document.querySelector("#total-beaten-sum").textContent) {
                            document.querySelector("#total-beaten-sum").textContent = json['total'];
                          }
                          

                          window.totalBeatenTiles.updateSeries(json['data'])
                        } else {
                          alert("HTTP-Error: " + response.status);
                        }
            }

            const getLeftData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                        let url = `/players/cricket/short_type`;
                        let payload = {
                            bat_contact: 'left',
                            start_date,
                            end_date,
                            compare_with_start,
                            compare_with_end,
                            selected_range_type
                        }
                        let response = await fetch(url, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                              // 'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: JSON.stringify(payload)
                        });
                        if (response.ok) { // if HTTP-status is 200-299
                          // get the response body (the method explained below)
                          let json = await response.json();
                          if (json['status'] == 'UP'){
                            $("#left-stat").html(`
                                <span class="text-success me-2">
                                    <i class="mdi mdi-arrow-up-bold"></i> 
                                    ${json['current_percent']}%
                                </span>
                                <span>than ${json['selected_range_type']}</span>
                            `) ;
                          } else {
                            $("#left-stat").html(`
                                <span class="text-danger me-2">
                                    <i class="mdi mdi-arrow-down-bold"></i>
                                    ${json['current_percent']}%
                                </span>
                                <span>than ${json['selected_range_type']}</span>
                            `) ;

                          }

                          if(document.querySelector("#total-left-sum") && document.querySelector("#total-left-sum").textContent) {
                            document.querySelector("#total-left-sum").textContent = json['total'];
                          }
                          
                          window.totalLeftTiles.updateSeries(json['data'])
                        } else {
                          alert("HTTP-Error: " + response.status);
                        }
            }

            const getBallBowled = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                        let url = `/players/cricket/ball_bowled`;
                        let payload = {
                            start_date,
                            end_date,
                            compare_with_start,
                            compare_with_end,
                            selected_range_type
                        }
                        let response = await fetch(url, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                              // 'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: JSON.stringify(payload)
                        });
                        if (response.ok) { // if HTTP-status is 200-299
                            let json = await response.json();
                            document.querySelector("#total-bowled-sum").textContent = json['total'];
                            if (json['status'] == 'UP'){
                                $("#bowled-stat").html(`${json['total']} percent higher then ${json['selected_range_type']}`);
                            } else {
                                $("#bowled-stat").html(`${json['total']} percent less then ${json['selected_range_type']}`);
                            }
                        }
            }

            const getAvgBallSpeed = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                        let url = `/players/cricket/avg_ball_speed`;
                        let payload = {
                            start_date,
                            end_date,
                            compare_with_start,
                            compare_with_end,
                            selected_range_type
                        }
                        let response = await fetch(url, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                              // 'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: JSON.stringify(payload)
                        });
                        if (response.ok) { // if HTTP-status is 200-299
                            let json = await response.json();
                            let points = [];
                            const speed_points = json['data'];
                            const max_speed = Math.max(...speed_points)
                            const min_speed = Math.min(...speed_points)
                            let max_speed_point_taken = false
                            let min_speed_point_taken = false
                            const createPoints = (point, i) => {
                                let axis = i + 1
                                // console.log("speed::::", point, "max_speed::::", max_speed)
                                // console.log("speed::::", point, "min_speed::::", min_speed)
                                if (((point == max_speed) && !max_speed_point_taken) || ((point == min_speed) && !min_speed_point_taken)) {
                                    if (point == max_speed){
                                        max_speed_point_taken = true
                                    } else {
                                        min_speed_point_taken = true
                                    }
                                    points.push({
                                      x: axis,
                                      y: point,
                                      marker: { size: 8, fillColor: "#fff", strokeColor: "#fa5c7c", radius: 2 },
                                      label: { borderColor: "#fa5c7c", offsetY: 0, offsetX: 10, style: { color: "#fff", background: "#fa5c7c" }, text: point }
                                    })
                                }
                            }
                            document.querySelector("#avg_ball_speed").textContent = json['avarage_ball_speed'];
                            
                            speed_points.map(createPoints);
                            window.avgBallSpeedTiles.updateOptions({
                                annotations: {points: points},
                                yaxis: { min: min_speed, max: max_speed, title: { text: "" }, tickAmount: 4 }
                            })
                            window.avgBallSpeedTiles.updateSeries([{ name: "Pace", data: speed_points}])
                    }
            }

            const getShortBowlingData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                    let url = `/players/cricket/bowling_types`;
                    let payload = {
                        ball_type: 'Short',
                        start_date,
                        end_date,
                        compare_with_start,
                        compare_with_end,
                        selected_range_type
                    }
                    let response = await fetch(url, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                          // 'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: JSON.stringify(payload)
                    });
                    if (response.ok) { // if HTTP-status is 200-299
                      // get the response body (the method explained below)
                      let json = await response.json();

                      if (document.querySelector("#total-short-ball") && document.querySelector("#total-short-ball").textContent){
                        document.querySelector("#total-short-ball").textContent = json['total'];
                      }
                      
                      
                      if (json['status'] == 'UP'){
                        $("#short-stat").html(`
                            <span class="text-success me-2">
                                <i class="mdi mdi-arrow-up-bold"></i> 
                                ${json['current_percent']}%
                            </span>
                            <span>than ${json['selected_range_type']}</span>
                        `);
                      } else {
                        $("#short-stat").html(`
                            <span class="text-danger me-2">
                                <i class="mdi mdi-arrow-down-bold"></i>
                                ${json['current_percent']}%
                            </span>
                            <span>than ${json['selected_range_type']}</span>
                        `);
                      }
                      // window.totalShortBowlingTiles.updateSeries([{
                      //   name: 'Short',
                      //   data: json['data']
                      // }])
                      window.totalShortBowlingTiles.updateSeries(json['data'])
                    } else {
                      alert("HTTP-Error: " + response.status);
                    }
            }

            const getGoodLengthBowlingData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
            let url = `/players/cricket/bowling_types`;
            let payload = {
                ball_type: 'GoodLength',
                start_date,
                end_date,
                compare_with_start,
                compare_with_end,
                selected_range_type
            }
            let response = await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(payload)
            });
            if (response.ok) { // if HTTP-status is 200-299
              // get the response body (the method explained below)
              let json = await response.json();
              if (json['status'] == 'UP'){
                $("#good-length-stat").html(`
                    <span class="text-success me-2">
                        <i class="mdi mdi-arrow-up-bold"></i> 
                        ${json['current_percent']}%
                    </span>
                    <span>than ${json['selected_range_type']}</span>
                `) ;
              } else {
                $("#good-length-stat").html(`
                    <span class="text-danger me-2">
                        <i class="mdi mdi-arrow-down-bold"></i>
                        ${json['current_percent']}%
                    </span>
                    <span>than ${json['selected_range_type']}</span>
                `) ;

              }
              if (document.querySelector("#total-good-length-sum") && document.querySelector("#total-good-length-sum").textContent) {
                document.querySelector("#total-good-length-sum").textContent = json['total'];
              }
              
              window.totalGoodLengthBowlingTiles.updateSeries(json['data'])
            } else {
              alert("HTTP-Error: " + response.status);
            }
            }

            const getFullLengthBowlingData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                let url = `/players/cricket/bowling_types`;
                let payload = {
                    ball_type: 'FullLength',
                    start_date,
                    end_date,
                    compare_with_start,
                    compare_with_end,
                    selected_range_type
                }
                let response = await fetch(url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                      // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: JSON.stringify(payload)
                });
                if (response.ok) { // if HTTP-status is 200-299
                  // get the response body (the method explained below)
                  let json = await response.json();

                  if (json['status'] == 'UP'){
                    $("#full-length-stat").html(`
                        <span class="text-success me-2">
                            <i class="mdi mdi-arrow-up-bold"></i> 
                            ${json['current_percent']}%
                        </span>
                        <span>than ${json['selected_range_type']}</span>
                    `) ;
                  } else {
                    $("#full-length-stat").html(`
                        <span class="text-danger me-2">
                            <i class="mdi mdi-arrow-down-bold"></i>
                            ${json['current_percent']}%
                        </span>
                        <span>than ${json['selected_range_type']}</span>
                    `) ;

                  }

                  document.querySelector("#total-full-length-sum").textContent = json['total'];

                  window.totalFullLengthBowlingTiles.updateSeries(json['data'])
                } else {
                  alert("HTTP-Error: " + response.status);
                }
            }

            const getOffTargettBowlingData = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                let url = `/players/cricket/bowling_types`;
                let payload = {
                    ball_type: 'HalfVally',
                    start_date,
                    end_date,
                    compare_with_start,
                    compare_with_end,
                    selected_range_type
                }
                let response = await fetch(url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                      // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: JSON.stringify(payload)
                });
                if (response.ok) { // if HTTP-status is 200-299
                  // get the response body (the method explained below)
                  let json = await response.json();
                  if (json['status'] == 'UP'){
                    $("#off-target-stat").html(`
                        <span class="text-success me-2">
                            <i class="mdi mdi-arrow-up-bold"></i> 
                            ${json['current_percent']}%
                        </span>
                        <span>than ${json['selected_range_type']}</span>
                    `) ;
                  } else {
                    $("#off-target-stat").html(`
                        <span class="text-danger me-2">
                            <i class="mdi mdi-arrow-down-bold"></i>
                            ${json['current_percent']}%
                        </span>
                        <span>than ${json['selected_range_type']}</span>
                    `) ;

                  }

                  document.querySelector("#total-off-target-sum").textContent = json['total'];
                  window.totalOffTargettBowlingTiles.updateSeries(json['data'])
                } else {
                  alert("HTTP-Error: " + response.status);
                }
            }

            const ballDistribution = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type, plot_for = null) => {
                    console.log("Ball distribution................................")
                    let url = `/players/cricket/ball_distribution`;
                    let payload = {
                        start_date,
                        end_date,
                        compare_with_start,
                        compare_with_end,
                        selected_range_type
                    }
                    let response = await fetch(url, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                          // 'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: JSON.stringify(payload)
                    });
                    if (response.ok) { // if HTTP-status is 200-299
                        let json = await response.json();
                        json['data'].map(d => {
                            if (d['pitch_cordinate'] !== null){
                                let color = "grey"
                                if (d['ball_hit_area'] == 'Middled') {
                                    color = "green"
                                } else if (d['ball_hit_area'] == 'edged') {
                                    color = "yellow"
                                } else if (d['ball_hit_area'] == 'beaten') {
                                    color = "grey"
                                } else if (d['ball_hit_area'] == 'left') {
                                    color = "blue"
                                } else if (d['ball_hit_area'] == 'wicket') {
                                    color = "red"
                                }

                                if (pitch_plot && d['ball_hit_area'] == pitch_plot) {
                                    console.log(d['ball_hit_area'], "  Row::::", parseInt(d['pitch_cordinate']['row']), "  col:::::", parseInt(d['pitch_cordinate']['col']), (parseInt(d['pitch_cordinate']['row']) > 10 || parseInt(d['pitch_cordinate']['col']) > 9)? "Invalid" : "Valid")
                                    // if(parseInt(d['pitch_cordinate']['row']) == 7 && parseInt(d['pitch_cordinate']['col']) == 1) {
                                        $(`#${parseInt(d['pitch_cordinate']['row'])}${parseInt(d['pitch_cordinate']['col'])}`).html(`
                                            <div class="ball ${color}"></div>`
                                        );
                                    // }
                                } else {
                                    console.log(d['ball_hit_area'], "  Row::::", parseInt(d['pitch_cordinate']['row']), "  col:::::", parseInt(d['pitch_cordinate']['col']), (parseInt(d['pitch_cordinate']['row']) > 10 || parseInt(d['pitch_cordinate']['col']) > 9)? "Invalid" : "Valid")
                                    $(`#${parseInt(d['pitch_cordinate']['row'])}${parseInt(d['pitch_cordinate']['col'])}`).html(`
                                        <div class="ball ${color}"></div>`
                                    );
                                }
                            }
                        })
                    }
            }

            const ballHitAreaCount = async (start_date, end_date, compare_with_start, compare_with_end, selected_range_type) => {
                        console.log("Ball Hit distribution................................")
                        let url = `/players/cricket/ball_hit_area_count`;
                        let payload = {
                            start_date,
                            end_date,
                            compare_with_start,
                            compare_with_end,
                            selected_range_type
                        }
                        let response = await fetch(url, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                              // 'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: JSON.stringify(payload)
                        });
                        if (response.ok) { // if HTTP-status is 200-299
                            let json = await response.json();
                            console.log("Ball hit area count:::::::", json)

                            document.querySelector("#pitch_map_middled").textContent = json['middled']['value'];
                            document.querySelector("#pitch_map_edged").textContent = json['edged']['value'];
                            document.querySelector("#pitch_map_beaten").textContent = json['beaten']['value'];
                            document.querySelector("#pitch_map_off_target").textContent = json['left']['value'];
                            document.querySelector("#pitch_map_wicket").textContent = json['wicket']['value'];
                        }
            }

            const shortBall =  async function (start_date=null, end_date=null) {
                if (i(".donut-container").length > 0) {
                    console.log("start_date::", start_date, "end_date:::", end_date)
                    let url = `/players/cricket/ball_types?start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                      let json = await response.json();
                      console.log("Short ball data:::::::::::::", json)
                      let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'Short'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'Short'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'Short'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'Short'},
                    ]
                      // d3.selectAll(".donut-chart").remove()
                      const cdc1 = new BriteChartApp(".donut-container", dataset);
                      cdc1.createDonutChart();
                    //   briteChartApp.createDonutChart(".donut-container", dataset);
                      let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                      document.querySelector("#sum_short_ball").textContent = total_ball;
                    } else {
                      alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const yorkerBall =  async function (start_date=null, end_date=null) {
                if (i(".donut-container2").length > 0){
                    let url = `/players/cricket/ball_types?ball_pitch=Yorker&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'Yorker'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'Yorker'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'Yorker'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'Yorker'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    const cdc1 = new BriteChartApp(".donut-container2", dataset);
                    cdc1.createDonutChart2();                  
                    //   briteChartApp.createDonutChart2(".donut-container2", dataset);
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#sum_yorker_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const goodLenthBall = async function (start_date=null, end_date=null){
                if (i(".donut-container3").length > 0){
                    let url = `/players/cricket/ball_types?ball_pitch=GoodLength&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'GoodLength'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'GoodLength'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'GoodLength'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'GoodLength'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    const cdc1 = new BriteChartApp(".donut-container3", dataset);
                    cdc1.createDonutChart3(".donut-container3", dataset);
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#sum_good_length_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const fullLenthBall = async function (start_date=null, end_date=null){
                if (i(".donut-container4").length > 0){
                    let url = `/players/cricket/ball_types?ball_pitch=FullLength&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'FullLength'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'FullLength'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'FullLength'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'FullLength'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    const cdc1 = new BriteChartApp(".donut-container4", dataset);
                    cdc1.createDonutChart4(".donut-container4", dataset);
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#sum_full_length_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const halfVallyBall = async function (start_date=null, end_date=null){
                if (i(".donut-container5").length > 0){
                    let url = `/players/cricket/ball_types?ball_pitch=HalfVally&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                      let json = await response.json();
                      let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'HalfVally'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'HalfVally'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'HalfVally'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'HalfVally'},
                    ]
                      // d3.selectAll(".donut-chart").remove()
                      const cdc1 = new BriteChartApp(".donut-container5", dataset);
                      cdc1.createDonutChart5(".donut-container5", dataset);
                      let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                      document.querySelector("#sum_half_vally_ball").textContent = total_ball;
                    } else {
                      alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const backOfTheLenthBall = async function (start_date=null, end_date=null){
                if (i(".donut-container6").length > 0){
                    let url = `/players/cricket/ball_types?ball_pitch=BackOfTheLength&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                      let json = await response.json();
                      
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'BackOfTheLength'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'BackOfTheLength'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'BackOfTheLength'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'BackOfTheLength'},
                    ]
                      // d3.selectAll(".donut-chart").remove()
                      const cdc1 = new BriteChartApp(".donut-container6", dataset);
                      cdc1.createDonutChart6(".donut-container6", dataset);
                      let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                      document.querySelector("#sum_back_of_the_length_ball").textContent = total_ball;
                    } else {
                      alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const battingHistorical = async function(){
                const url = `/players/cricket/batting_historical`;
                const response = await fetch(url);
                if (response.ok) { 
                  let json = await response.json();
                  let bowlingColors = ["#B3A1A4", "#DFBAA2", "#C0CB9C", "#2699FB", "#C934EB", "#2D8517"];
                //   (dataColors = $("#bowling-data-chart").data("colors")) && (bowlingColors = dataColors.split(","));
                  const bowlingOptions = {
                      chart: { height: 443, type: "line", toolbar: { show: !1 } },
                      stroke: { curve: "smooth", width: 2 },
                    //   series: [
                    //       { name: "Short Balls", type: "line", data: [44, 55, 31, 47, 31, 43, 26, 41, 31, 47, 33, 43] },
                    //       { name: "Good Length", type: "line", data: [10, 12, 8, 14, 16, 13, 18, 10, 8, 20, 14, 11] },
                    //       { name: "Full Length", type: "line", data: [26, 30, 20, 40, 43, 25, 27, 33, 37, 22, 27, 22] },
                    //       { name: "Off Target", type: "line", data: [55, 69, 45, 61, 43, 54, 37, 52, 44, 61, 43, 56] },
                    //   ],
                      series: [
                        { name: "Short Balls", type: "line", data:  json['data']['short']},
                        { name: "Good Length", type: "line", data: json['data']['good_length'] },
                        { name: "Full Length", type: "line", data: json['data']['full_length'] },
                        { name: "Half Vally", type: "line", data: json['data']['half_vally'] },
                        { name: "Yorker", type: "line", data: json['data']['yorker'] },
                        { name: "Back Of The Length", type: "line", data: json['data']['back_of_the_length'] },
                    ],
                      // series: [],
                      fill: { type: "solid", opacity: [0.35, 1] },
                    //   labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                      // labels: [],
                      labels: json['lavels'],
                      markers: { size: 0 },
                      colors: bowlingColors,
                      yaxis: [{ title: { text: "Number of Balls" }, min: 0 }],
                      tooltip: {
                          shared: !0,
                          intersect: !1,
                          y: {
                              formatter: function (o) {
                                  return void 0 !== o ? o.toFixed(0) + " balls" : o;
                              },
                          },
                      },
                      grid: { borderColor: "#f1f3fa", padding: { bottom: 5 } },
                      legend: { fontSize: "14px", fontFamily: "14px", offsetY: 5 },
                      responsive: [{ breakpoint: 600, options: { yaxis: { show: !1 }, legend: { show: !1 } } }],
                  };
                  new ApexCharts(document.querySelector("#batting-data-chart"), bowlingOptions).render();
                }
            }

            const shortDirection = async function(start_date=null, end_date=null, compare_with_start=null, compare_with_end=null, selected_range_type=null, ball_type=null){
            if (i("#total-ball-played").length > 0){
                let url = `/players/cricket/short_distribution?start_date=${start_date}&end_date=${end_date}&compare_with_start=${compare_with_start}&compare_with_end=${compare_with_end}&ball_type=${ball_type}`;
                let response = await fetch(url);
                if (response.ok) { 
                  let json = await response.json();

                  let third_man = json['short_distribution_group'].find(o => o['_id'] == 'third-man') || {count: 0}
                  let deep_point = json['short_distribution_group'].find(o => o['_id'] == 'deep-point') || {count: 0}
                  let deep_cover = json['short_distribution_group'].find(o => o['_id'] == 'deep-cover') || {count: 0}
                  let long_off = json['short_distribution_group'].find(o => o['_id'] == 'long-off') || {count: 0}

                  let deep_fine_leg = json['short_distribution_group'].find(o => o['_id'] == 'deep-fine-leg') || {count: 0}
                  let deep_square_leg = json['short_distribution_group'].find(o => o['_id'] == 'deep-square-leg') || {count: 0}
                  let deep_mid_wicket = json['short_distribution_group'].find(o => o['_id'] == 'deep-mid-wicket') || {count: 0}
                  let long_on = json['short_distribution_group'].find(o => o['_id'] == 'long-on') || {count: 0}
                  
                  let total_run = third_man.count + deep_point.count + deep_cover.count + long_off.count + deep_fine_leg.count + deep_square_leg.count + deep_mid_wicket.count + long_on.count

                  document.querySelector("#total-ball-played").textContent = json['total_ball_faced'];
                  
                  document.querySelector(".off-side1").textContent = third_man ? third_man.count : 0; //315
                  document.querySelector(".off-side2").textContent = deep_point ? deep_point.count : 0; //270
                  document.querySelector(".off-side3").textContent = deep_cover ? deep_cover.count : 0; //225
                  document.querySelector(".off-side4").textContent = long_off ? long_off.count : 0; //180


                  document.querySelector(".on-side1").textContent = deep_fine_leg ? deep_fine_leg.count : 0; //0
                  document.querySelector(".on-side2").textContent = deep_square_leg ? deep_square_leg.count : 0; //45
                  document.querySelector(".on-side3").textContent = deep_mid_wicket ? deep_mid_wicket.count : 0; //90
                  document.querySelector(".on-side4").textContent = long_on ? long_on.count : 0; //135

                  const dig0 = shortDirectionPercent(total_run, deep_fine_leg.count)
                  const dig45 = shortDirectionPercent(total_run, deep_square_leg.count)
                  const dig90 = shortDirectionPercent(total_run, deep_mid_wicket.count)
                  const dig135 = shortDirectionPercent(total_run, long_on.count)
                  const dig180 = shortDirectionPercent(total_run, long_off.count)
                  const dig225 = shortDirectionPercent(total_run, deep_cover.count)
                  const dig270 = shortDirectionPercent(total_run, deep_point.count)
                  const dig315 = shortDirectionPercent(total_run, third_man.count)
                  
                    const style_str = "conic-gradient("+dig0+" 0deg, "+dig0+" 45deg, "+dig45+" 45deg, "+dig45+" 90deg, "+dig90+" 90deg, "+dig90+" 135deg, "+dig135+" 135deg, "+dig135+" 180deg, "+dig180+" 180deg, "+dig180+" 225deg, "+dig225+" 225deg, "+dig225+" 270deg, "+dig270+" 270deg, "+dig270+" 315deg, "+dig315+" 315deg)";
                    console.log(style_str)
                    document.getElementById("cricket_ground").style.backgroundImage = style_str;
                } else {
                  alert("HTTP-Error: " + response.status);
                }
            } 
            }

            const shortDirectionPercent = function(total_run, section_run){
                console.log("total_run::::", total_run)
                console.log("section_run::::", section_run)

                const persent = (section_run/total_run) * 100
                console.log("persent::::", persent)
                let color = '#8CC63F'
                
                if (persent >= 30){
                    color = '#056839'
                } else if(persent >= 10 && persent < 30){
                    color = '#539540'
                } 
                console.log('color::::::',color)
                return color
            }

            const bowlerFullLenthBall = async function (start_date=null, end_date=null){
                if (i(".bowler_donut-container2").length > 0){
                    let url = `/players/cricket/ball_hit_area_type?ball_pitch=FullLength&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                      let json = await response.json();
                      console.log("Ball hit area type:::::::::", json)
                      let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'FullLength'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'FullLength'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'FullLength'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'FullLength'},
                    ]
                      // d3.selectAll(".donut-chart").remove()
                    //   briteChartApp.createDonutChart5(".bowler_donut-container2", dataset);
                        const cdc1 = new BriteChartApp(".bowler_donut-container2", dataset);
                        cdc1.createDonutChart9();
                      let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                      document.querySelector("#bowler_sum_full_length_ball").textContent = total_ball;
                    } else {
                      alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const bowlerGoodLenthBall = async function (start_date=null, end_date=null){
                if (i(".bowler_donut-container3").length > 0){
                    let url = `/players/cricket/ball_hit_area_type?ball_pitch=GoodLength&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    console.log("Ball hit area type:::::::::", json)
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'GoodLength'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'GoodLength'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'GoodLength'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'GoodLength'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    const cdc1 = new BriteChartApp(".bowler_donut-container3", dataset);
                    cdc1.createDonutChart8();
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#bowler_sum_good_length_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const bowlerShortBall = async function (start_date=null, end_date=null){
                if (i(".bowler_donut-container4").length > 0){
                    let url = `/players/cricket/ball_hit_area_type?ball_pitch=Short&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    console.log("Ball hit area type:::::::::", json)
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'Short'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'Short'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'Short'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'Short'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    const cdc1 = new BriteChartApp(".bowler_donut-container4", dataset);
                    cdc1.createDonutChart7();
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#bowler_sum_short_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const bowlerYorkerBall = async function (start_date=null, end_date=null){
                if (i(".bowler_donut-container3").length > 0){
                    let url = `/players/cricket/ball_hit_area_type?ball_pitch=Yorker&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    console.log("Ball hit area type:::::::::", json)
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'Yorker'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'Yorker'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'Yorker'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'Yorker'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    // briteChartApp.createDonutChart10(".bowler_donut-container5", dataset);
                    const cdc1 = new BriteChartApp(".bowler_donut-container5", dataset);
                    cdc1.createDonutChart11();
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#bowler_sum_yorker_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const bowlerHalfVallyBall = async function (start_date=null, end_date=null){
                if (i(".bowler_donut-container3").length > 0){
                    let url = `/players/cricket/ball_hit_area_type?ball_pitch=HalfVally&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                    let json = await response.json();
                    console.log("Ball hit area type:::::::::", json)
                    let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'HalfVally'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'HalfVally'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'HalfVally'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'HalfVally'},
                    ]
                    // d3.selectAll(".donut-chart").remove()
                    // briteChartApp.createDonutChart11(".bowler_donut-container6", dataset);
                    const cdc1 = new BriteChartApp(".bowler_donut-container6", dataset);
                    cdc1.createDonutChart10();
                    let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                    document.querySelector("#bowler_sum_half_vally_ball").textContent = total_ball;
                    } else {
                    alert("HTTP-Error: " + response.status);
                    }
                }
            }

            const bowlerBackOfTheLengthBall = async function (start_date=null, end_date=null){
                if (i(".bowler_donut-container3").length > 0){
                    let url = `/players/cricket/ball_hit_area_type?ball_pitch=BackOfTheLength&start_date=${start_date}&end_date=${end_date}`;
                    let response = await fetch(url);
                    if (response.ok) { 
                      let json = await response.json();
                      console.log("Ball hit area type:::::::::", json)
                      let  dataset = [
                        { name: "Middled", id: 1, quantity: json['middled']['value'], percentage: json['middled']['present'], ball_type: 'BackOfTheLength'},
                        { name: "Edged", id: 2, quantity: json['edged']['value'], percentage: json['edged']['present'], ball_type: 'BackOfTheLength'},
                        { name: "Left", id: 3, quantity: json['left']['value'], percentage: json['left']['present'], ball_type: 'BackOfTheLength'},
                        { name: "Missed", id: 4, quantity: json['beaten']['value'], percentage: json['beaten']['present'], ball_type: 'BackOfTheLength'},
                    ]
                      // d3.selectAll(".donut-chart").remove()
                    //   briteChartApp.createDonutChart12(".bowler_donut-container7", dataset);
                    const cdc1 = new BriteChartApp(".bowler_donut-container7", dataset);
                    cdc1.createDonutChart12();
                      let total_ball = parseInt(json['middled']['value']) + parseInt(json['edged']['value']) + parseInt(json['left']['value']) + parseInt(json['beaten']['value'])
                      document.querySelector("#bowler_sum_back_of_the_length_ball").textContent = total_ball;
                    } else {
                      alert("HTTP-Error: " + response.status);
                    }
                }
            }
            
            const bowlingHistorical = async function (){
                const url = `/players/cricket/bowling_historical`;
                const response = await fetch(url);
                if (response.ok) { 
                  let json = await response.json();
                  let bowlingColors = ["#B3A1A4", "#DFBAA2", "#C0CB9C", "#2699FB", "#C934EB", "#2D8517"];
                //   (dataColors = $("#bowling-data-chart").data("colors")) && (bowlingColors = dataColors.split(","));
                  const bowlingOptions = {
                      chart: { height: 443, type: "line", toolbar: { show: !1 } },
                      stroke: { curve: "smooth", width: 2 },
                    //   series: [
                    //       { name: "Short Balls", type: "line", data: [44, 55, 31, 47, 31, 43, 26, 41, 31, 47, 33, 43] },
                    //       { name: "Good Length", type: "line", data: [10, 12, 8, 14, 16, 13, 18, 10, 8, 20, 14, 11] },
                    //       { name: "Full Length", type: "line", data: [26, 30, 20, 40, 43, 25, 27, 33, 37, 22, 27, 22] },
                    //       { name: "Off Target", type: "line", data: [55, 69, 45, 61, 43, 54, 37, 52, 44, 61, 43, 56] },
                    //   ],
                      series: [
                        { name: "Short Balls", type: "line", data:  json['data']['short']},
                        { name: "Good Length", type: "line", data: json['data']['good_length'] },
                        { name: "Full Length", type: "line", data: json['data']['full_length'] },
                        { name: "Half Vally", type: "line", data: json['data']['half_vally'] },
                        { name: "Yorker", type: "line", data: json['data']['yorker'] },
                        { name: "Back Of The Length", type: "line", data: json['data']['back_of_the_length'] },
                    ],
                      // series: [],
                      fill: { type: "solid", opacity: [0.35, 1] },
                    //   labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                      // labels: [],
                      labels: json['lavels'],
                      markers: { size: 0 },
                      colors: bowlingColors,
                      yaxis: [{ title: { text: "Number of Balls" }, min: 0 }],
                      tooltip: {
                          shared: !0,
                          intersect: !1,
                          y: {
                              formatter: function (o) {
                                  return void 0 !== o ? o.toFixed(0) + " balls" : o;
                              },
                          },
                      },
                      grid: { borderColor: "#f1f3fa", padding: { bottom: 5 } },
                      legend: { fontSize: "14px", fontFamily: "14px", offsetY: 5 },
                      responsive: [{ breakpoint: 600, options: { yaxis: { show: !1 }, legend: { show: !1 } } }],
                  };
                  new ApexCharts(document.querySelector("#bowling-data-chart"), bowlingOptions).render();
                }
            }

            $("#shot_distribution_filter").change(function () {
                var ball_type = this.value;
                shortDirection(window.startDate, window.endDate, window.compareStartDate, window.compareEndDate, window.selectedDateRangeType, ball_type); 
            });

            $(".dropdown-item").click(function(e) {
                let filter_val = e.value;
                console.log(filter_val)
            })


        // async function battingHistorical(){
        //     if (i("#total-ball-played").length > 0){
        //         let url = 'http://localhost:3000/players/cricket/batting_historical';
        //         let response = await fetch(url);
        //         if (response.ok) { 
        //           let json = await response.json();
        //           console.log("json::::::", json['short_distribution_group'].find(o => o['_id'] === 'Square')['count'])
        //           document.querySelector("#total-ball-played").textContent = json['total_ball_faced'];
        //           document.querySelector(".off-side1").textContent = json['short_distribution_group'].find(o => o['_id'] === 'Square')['count'];
        //           document.querySelector(".off-side2").textContent = json['short_distribution_group'].find(o => o['_id'] === 'Off')['count'];
        //           document.querySelector(".off-side3").textContent = json['short_distribution_group'].find(o => o['_id'] === 'OffDrive')['count'];

        //           document.querySelector(".on-side1").textContent = json['short_distribution_group'].find(o => o['_id'] === 'SquareLeg')['count'];
        //           document.querySelector(".on-side2").textContent = json['short_distribution_group'].find(o => o['_id'] === 'On')['count'];
        //           document.querySelector(".on-side3").textContent = json['short_distribution_group'].find(o => o['_id'] === 'OnDrive')['count'];
        //         } else {
        //           alert("HTTP-Error: " + response.status);
        //         }
        //     } 
        // }


        i(window).on("resize", function (e) {
            e.preventDefault(), setTimeout(u, 200);
        })
    
            function cb(start, end) {
                // if (moment().subtract(0, 'days')) {
                //     $('#reportrange span').html('Today ' + ' - ' + start.format('MMMM D, YYYY'));
                // } else {
                //     $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
                // }
                $('#reportrange span').html(moment(start.format('MMMM D, YYYY')).isSame(moment(), 'day') ? 'Today' + ' - ' + end.format('MMMM D, YYYY') :  start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
                
                console.log("Start::::", start.format('YYYY-MM-DD'))
                console.log("End::::", end.format('YYYY-MM-DD'))
               

                let selected_range_type
                let compare_with_start
                let compare_with_end

                if (start.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD') && end.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
                    selected_range_type = 'Today'
                    compare_with_start = moment().subtract(1, 'days')
                    compare_with_end = moment().subtract(1, 'days')
                } else if (start.format('YYYY-MM-DD') == moment().subtract(1, 'days').format('YYYY-MM-DD') && end.format('YYYY-MM-DD') == moment().subtract(1, 'days').format('YYYY-MM-DD')){
                    selected_range_type = 'Yesterday'
                    compare_with_start = moment().subtract(2, 'days')
                    compare_with_end = moment().subtract(2, 'days')
                } else if (start.format('YYYY-MM-DD') == moment().subtract(6, 'days').format('YYYY-MM-DD') && end.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
                    selected_range_type = 'Last 7 Days'
                    compare_with_start = moment().subtract(12, 'days')
                    compare_with_end = moment().subtract(6, 'days')
                } else if (start.format('YYYY-MM-DD') == moment().subtract(29, 'days').format('YYYY-MM-DD') && end.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
                    selected_range_type = 'Last 30 Days'
                    compare_with_start = moment().subtract(58, 'days')
                    compare_with_end = moment().subtract(29, 'days')
                } else if (start.format('YYYY-MM-DD') == moment().startOf('month').format('YYYY-MM-DD') && end.format('YYYY-MM-DD') == moment().endOf('month').format('YYYY-MM-DD')){
                    selected_range_type = 'This Month'
                    compare_with_start = moment().subtract(1, 'month').startOf('month')
                    compare_with_end = moment().subtract(1, 'month').endOf('month')
                } else if (start.format('YYYY-MM-DD') == moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD') && end.format('YYYY-MM-DD') == moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')){
                    selected_range_type = 'Last Month'
                    compare_with_start = moment().subtract(2, 'month').startOf('month')
                    compare_with_end = moment().subtract(2, 'month').endOf('month')
                } else {
                    selected_range_type = 'Custom'
                    let days_diff = end.diff(start, 'days')
                    compare_with_start = moment(start.format('YYYY-MM-DD'), 'YYYY-MM-DD').subtract(days_diff+2, 'days')
                    compare_with_end = moment(start.format('YYYY-MM-DD'), 'YYYY-MM-DD').subtract(1, 'day')
                }

                window.startDate = start.format('YYYY-MM-DD');
                window.endDate = end.format('YYYY-MM-DD');
                window.compareStartDate = compare_with_start.format('YYYY-MM-DD');
                window.compareEndDate = compare_with_end.format('YYYY-MM-DD');
                window.selectedDateRangeType = selected_range_type;

                if (current_parh == '/players/cricket/dashboard'){
                    localStorage.setItem('batting_dashboard_start_date', start.format('YYYY-MM-DD'));
                    localStorage.setItem('batting_dashboard_end_date', end.format('YYYY-MM-DD'));
                    // if (window.shortBall) {
                    //     window.shortBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    // }

                    shortBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
                    yorkerBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    goodLenthBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    fullLenthBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    halfVallyBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    backOfTheLenthBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    
                    shortDirection(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type); 
                    

                    getLeftData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getBeatenData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getEdgeData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getMiddledData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    battingHistorical();
                }
                   
                if (current_parh == '/players/cricket/bowler_dashboard'){
                    localStorage.setItem('bowling_dashboard_start_date', start.format('YYYY-MM-DD'));
                    localStorage.setItem('bowling_dashboard_end_date', end.format('YYYY-MM-DD'));
                    getShortBowlingData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getGoodLengthBowlingData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getFullLengthBowlingData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getOffTargettBowlingData(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type);
                    getBallBowled(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type)
                    getAvgBallSpeed(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type)
                    ballDistribution(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type)
                    ballHitAreaCount(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), compare_with_start.format('YYYY-MM-DD'), compare_with_end.format('YYYY-MM-DD'), selected_range_type)
                    bowlerFullLenthBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    bowlerGoodLenthBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    bowlerShortBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    bowlerYorkerBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    bowlerHalfVallyBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    bowlerBackOfTheLengthBall(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    bowlingHistorical();
                }
            }
    
            // var SpecialToDate = start.format('MMMM D, YYYY');
            // console.log(moment(start.format('MMMM D, YYYY')).isSame(moment(), 'day'))
            
            if ( $( "#reportrange" ).length ) {
                $('#reportrange').daterangepicker({
                    startDate: start,
                    endDate: end,
                    ranges: {
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    }
                }, cb);
        
                cb(start, end);
            }
    
            (t.prototype.initSelect2 = function () {
                n('[data-toggle="select2"]').select2();
            }),
            (t.prototype.initMask = function () {
                n('[data-toggle="input-mask"]').each(function (t, e) {
                    var a = n(e).data("maskFormat"),
                        o = n(e).data("reverse");
                    null != o ? n(e).mask(a, { reverse: o }) : n(e).mask(a);
                });
            }),
            (t.prototype.initDateRange = function () {
                var o = { cancelClass: "btn-light", applyButtonClasses: "btn-success" };
                n('[data-toggle="date-picker"]').each(function (t, e) {
                    var a = n.extend({}, o, n(e).data());
                    n(e).daterangepicker(a);
                });
                var i = {
                    startDate: moment().subtract(29, "days"),
                    endDate: moment(),
                    ranges: {
                        Today: [moment(), moment()],
                        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                        "Last 7 Days": [moment().subtract(6, "days"), moment()],
                        "Last 30 Days": [moment().subtract(29, "days"), moment()],
                        "This Month": [moment().startOf("month"), moment().endOf("month")],
                        "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                    },
                };
                n('[data-toggle="date-picker-range"]').each(function (t, e) {
                    var a = n.extend({}, i, n(e).data()),
                        o = a.targetDisplay;
                    n(e).daterangepicker(a, function (t, e) {
                        o && n(o).html(t.format("MMMM D, YYYY") + " - " + e.format("MMMM D, YYYY"));
                    });
                });
            }),
            (t.prototype.initTimePicker = function () {
                var o = { showSeconds: !0, icons: { up: "mdi mdi-chevron-up", down: "mdi mdi-chevron-down" } };
                n('[data-toggle="timepicker"]').each(function (t, e) {
                    var a = n.extend({}, o, n(e).data());
                    n(e).timepicker(a);
                });
            }),
            (t.prototype.initTouchspin = function () {
                var o = {};
                n('[data-toggle="touchspin"]').each(function (t, e) {
                    var a = n.extend({}, o, n(e).data());
                    n(e).TouchSpin(a);
                });
            }),
            (t.prototype.initMaxlength = function () {
                var o = { warningClass: "badge bg-success", limitReachedClass: "badge bg-danger", separator: " out of ", preText: "You typed ", postText: " chars available.", placement: "bottom" };
                n('[data-toggle="maxlength"]').each(function (t, e) {
                    var a = n.extend({}, o, n(e).data());
                    n(e).maxlength(a);
                });
            }),
            (t.prototype.init = function () {
                this.initSelect2(), this.initMask(), this.initDateRange(), this.initTimePicker(), this.initTouchspin(), this.initMaxlength();
            }),
            (i.AdvanceFormApp = new t()),
            (i.AdvanceFormApp.Constructor = t);

            
        })(window.jQuery, briteChartApp)
});
